/**
 * The 3D viewport renders directly in an ECI-like inertial frame: the Earth
 * mesh is what rotates (by `-gmst(epoch)`, matching `eciToEcef`'s own
 * `rotateZ(-gmst)` convention in `packages/astro/src/frames.ts`), while the
 * vehicle marker and orbit ribbon — both naturally ECI quantities already —
 * need no per-frame transform at all. `eciToThree` is the one place the axis
 * convention is fixed: ECI's spin axis (z) maps to three.js's up axis (y).
 */

/** 1 scene unit = 1000 km, so Earth's ~6378 km radius is a friendly ~6.4 units for the camera/controls. */
export const SCENE_SCALE = 1 / 1_000_000;

export const toScene = (meters: number): number => meters * SCENE_SCALE;

export function eciDirectionToThree(
  v: readonly [number, number, number],
): [number, number, number] {
  return [v[0], v[2], -v[1]];
}

export function eciToThree(v: readonly [number, number, number]): [number, number, number] {
  const [x, y, z] = eciDirectionToThree(v);
  return [toScene(x), toScene(y), toScene(z)];
}
